// Placeholder imagery for Phase 1. Replace with founder-supplied originals.
export const HERO_OFFICE =
  "https://images.unsplash.com/photo-1615803697515-3cb782c2a65a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const CONTACT_DESK =
  "https://images.unsplash.com/photo-1764087957302-ef0756ed8e0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const TAX_OPTIMIZATION_URL = "https://tax-optimization.jennaemichelle.com";
